Object.defineProperty(exports, "__esModule", { value: true });
exports.sharingNotificationIcon = void 0;
var share_xsmall_1 = require("../../../img/share_xsmall");
exports.sharingNotificationIcon = {
    isProfile: true,
    systemSvg: null,
    secondSvg: share_xsmall_1.shareXS,
};
//# sourceMappingURL=SharingNotificationIcon.js.map